"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    STUDENT_CANCEL_LESSON: 'student_cancel_lesson',
    TUTOR_CANCEL_LESSON: 'tutor_cancel_lesson',
    ABSENCE_STUDENT: 'absence_student',
    ABSENCE_TUTOR: 'absence_tutor',
};
//# sourceMappingURL=bookingReasonOptionTypes.js.map